<template>
  <div style="height: 40vh;">
      <div class="title" style="height: 3vh">D4 Fishbone diagram</div>
      <div style="border: 1px solid #2c7be8;height: 90%;overflow: hidden;">
        <el-carousel tyle="border:0px;" height="37vh" :interval="5000" arrow="always">
          <el-carousel-item v-for="item in src" :key="item">
            <img
              style="width: 100%;height:100%;object-fit: cover"
              :src="item"
            />
          </el-carousel-item>
        </el-carousel>
      </div>
  </div>
</template>

<script>
export default {
  name: "fr5d",
  props: {
    bean: {
      type: Object,
      default: function () { 
        return {};
      },
    },
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        if (val["fishboneDiagram"]) {
          this.src = val["fishboneDiagram"];
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      src: [],
      startCharts: null,
    };
  },
  mounted() {},
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>
<style scoped>
.title {
  width: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
  font-weight: bold;
  text-align: left;
  font-size: 15px;
  z-index: 1;
  text-shadow: 0 0 5px #fff, 0 0 35px #33ccff, 0 0 45px #33ccff,
    0 0 50px #33ccff;
}

.bad-scroll{
    overflow-y:auto
}
.bad-scroll::-webkit-scrollbar {
    width: 4px;
    height: 1px;
}

.bad-scroll::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    background: white;
}
.bad-scroll::-webkit-scrollbar-track {/*滚动条里面轨道*/
    border-radius: 10px;
    background: #EDEDED;
}
</style>


// WEBPACK FOOTER //
// src/pages/fr/8d/component/5d.vue